import client from "/src/services/client";

export default {
    getAll: (params = {}) => client.get(`messaging/withheld-destinations`, params),
};
